/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C1_DescInputs */

const en_cad_learn_c1_desc = /** @type {(inputs: Cad_Learn_C1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the command line and coordinates to draw lines, circles and rectangles.`)
};

/**
* | output |
* | --- |
* | "Use the command line and coordinates to draw lines, circles and rectangles." |
*
* @param {Cad_Learn_C1_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c1_desc = /** @type {((inputs?: Cad_Learn_C1_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C1_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c1_desc(inputs)
});
export { cad_learn_c1_desc as "cad.learn.c1_desc" }